export let INotificationType = /*#__PURE__*/function (INotificationType) {
  INotificationType["DEFAULT"] = "default";
  INotificationType["ERROR"] = "error";
  INotificationType["WARNING"] = "warning";
  INotificationType["INFO"] = "info";
  INotificationType["SUCCESS"] = "success";
  INotificationType["HOT_PRODUCTS"] = "hot product";
  return INotificationType;
}({});